"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGuideSliderView = void 0;
var React = require("react");
exports.DbGuideSliderView = function (props) {
    if (!props.photos)
        return;
    var renderPhotoSlide = function (photo, i) { return (React.createElement("div", { key: i, className: "c-guides__slide" },
        React.createElement("img", { src: photo }))); };
    var renderControls = function () { return (React.createElement("div", { className: "c-guides__controls" },
        React.createElement("div", { onClick: props.onSliderPrevClick, className: "c-guides__control c-guides__control--left" },
            React.createElement("span", { className: "fas fa-chevron-left" })),
        React.createElement("div", { onClick: props.onSliderNextClick, className: "c-guides__control c-guides__control--right" },
            React.createElement("span", { className: "fas fa-chevron-right" })))); };
    return (React.createElement("div", { className: "c-guides__slider" },
        React.createElement("div", { id: "detail-slider", className: "c-guides__slides" }, props.photos.map(renderPhotoSlide)),
        props.photos.length > 1 ? renderControls() : ''));
};
